import { thor } from "../../typings/thor";
import { Enums } from "../../thor.enums";
import "./service";

class LocaleCurrencyFilter {
    public static $inject: string[] = ["localeNumber"];

    constructor(localeNumber) {
        return (amount: number, currency: Enums.Currency) => {
            return localeNumber.formatCurrency(amount, currency);
        };
    }
}

class LocaleCurrencyEstimatesFilter {
    public static $inject: string[] = ["localeNumber"];

    constructor(localeNumber) {
        return (estimates: thor.ItemPricingEstimates, currency: Enums.Currency) => {
            const min = estimates?.min || 0;
            const max = estimates?.max || 0;
            const formatEstimate = (v: number) => (v > 0 ? localeNumber.formatCurrency(v, currency) : v);
            return formatEstimate(min) + (max > 0 ? ` - ${formatEstimate(max)}` : "");
        };
    }
}

class FormatPercentFilter {
    public static $inject: string[] = ["localeNumber"];

    constructor(localeNumber) {
        return (amount: number) => localeNumber.formatPercent(amount);
    }
}

angular
    .module("thor.core.locale-number.currency.filter", [
        "thor.core.locale-number.service"
    ])
    .filter("localeCurrency", <any>LocaleCurrencyFilter)
    .filter("localeCurrencyEstimates", <any>LocaleCurrencyEstimatesFilter)
    .filter("formatPercent", <any>FormatPercentFilter);
